import * as Sentry from '@sentry/browser';

export function notifyHandledException(error: Error): string {
  // eslint-disable-next-line no-console -- This console log makes the handled exceptions visible to the developer, hence improves debugging.
  console.log('Handled Error =>', error);
  return Sentry.captureException(error);
}

export const SENTRY_ALLOWED_URLS = [
  'https://embarkvet.com/',
  'https://shop.embarkvet.com/',
  'https://my.embarkvet.com/',
  'https://front.embarkvet.com/',
  'https://cnd.shopify.com/',
];
